import 'core-js/stable'

window.jQuery = window.$ = require('jquery')



// WEBPACK FOOTER //
// ./src/polyfill.js